<template>
  <div class="aigc-home">
    <div class="aigc-home-top">
      <div class="aigc-home-brand">
        <img class="aigc-home-brand-logo" :src="brandLogo" alt="" />
        <span class="aigc-home-brand-text">白云AI短剧创作平台</span>
      </div>
      <a
        v-if="!isLoggedIn"
        href="javascript:;"
        class="aigc-home-top-link"
        @click="goLogin"
      >登录</a>
    </div>

    <div class="aigc-home-hero">
      <div class="aigc-home-hero-bg">
        <video
          :src="heroVideoSrc"
          autoplay
          loop
          muted
          playsinline
        />
      </div>
      <div class="aigc-home-hero-inner">
        <h1 class="aigc-home-title">一站式 AI 漫剧创作平台 释放你的创意潜能</h1>
        <p class="aigc-home-sub">
          更多模型 更低价格 小成本成就大爆款 你的专属工作室
        </p>
        <div class="aigc-home-actions">
          <van-button
            round
            block
            type="info"
            native-type="button"
            class="aigc-home-btn-primary"
            @click="onExperience"
          >
            立即体验
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import heroVideo from "./assets/hz-adv-1.mp4";
import brandLogo from "./assets/aigc-brand-logo.png";
import util from "@/util/util";
export default {
  name: "AigcHome",
  data() {
    return {
      heroVideoSrc: heroVideo,
      brandLogo,
    };
  },
  computed: {
    isLoggedIn() {
      return !!util.getCookie("front_token");
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
  methods: {
    hasToken() {
      return !!util.getCookie("front_token");
    },
    goLogin() {
      this.$router.push({
        name: "aigc_login",
        query: { redirect: encodeURIComponent("/aigc/home") },
      });
    },
    onExperience() {
      if (!this.hasToken()) {
        this.$router.push({
          name: "aigc_login",
          query: { redirect: encodeURIComponent("/aigc/create") },
        });
        return;
      }
      this.$router.push({ name: "aigc_create" });
    },
  },
};
</script>

<style scoped>
.aigc-home {
  position: relative;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #000;
}

.aigc-home-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding:20px
}

.aigc-home-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.aigc-home-brand-logo {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.aigc-home-brand-text {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: 1.25;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
  min-width: 0;
}

.aigc-home-top-link {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.95);
  text-decoration: none;
  padding: 6px 14px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.aigc-home-hero {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.aigc-home-hero-bg {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.aigc-home-hero-bg video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.aigc-home-hero-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

.aigc-home-hero-inner {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 30px 20px;
  max-width: 400px;
  width: 100%;
  box-sizing: border-box;
}

.aigc-home-title {
  margin: 0 0 16px;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  line-height: 1.35;
  letter-spacing: 0.5px;
}

.aigc-home-sub {
  margin: 0 0 50px;
  font-size: 14px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.88);
}

.aigc-home-actions {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.aigc-home-btn-primary {
  height: 46px;
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcHome.vue